import moment from 'moment';

/**
 * Formats the given date in the 'MMMM DD, YYYY [at] h:mm A' format.
 * The date is parsed in its original timezone.
 *
 * @param {string} date - The date to format, in ISO 8601 format.
 * @returns {string} The formatted date.
 */
export const formatDate = (date) =>
  moment.parseZone(date).format('MMMM DD, YYYY [at] h:mm A');
